import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 30929 38884"
    {...props}
  >
    <path
      d="M29344 14595h-2919v-3164C26425 5128 21960 0 16471 0h-1513C9468 0 5003 5128 5003 11431v3164H1584c-875 0-1584 709-1584 1583v21121c0 876 709 1585 1584 1585h27760c876 0 1585-710 1585-1585V16178c0-874-708-1583-1585-1583zM17075 26776l896 5018-4262-9 694-5084c-943-339-1053-1346-1053-2405 0-1349 1096-2444 2447-2444 1349 0 2442 1095 2442 2444-1 1058-223 2140-1164 2480zm5317-12181H9038v-3164c0-4079 2655-7397 5920-7397h1513c3265 0 5921 3318 5921 7397v3164z"
      style={{
        fill: "#2b2a29",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
